import HTTP from "@/http-common";

export const state = {
  appointments: [],
  availableSlots: [],
  appointmentSearch: {
    keyword: null,
    statusFilter: -1,
    pageSize: 50
  }
};

export const getters = {
  availableSlots: state => {
    return state.availableSlots;
  },
  appointments: state => {
    return state.appointments;
  },
  appointmentSearch: state => {
    return state.appointmentSearch;
  }
};

export const mutations = {
  SET_AVAILABLE_SLOTS(state, data) {
    state.availableSlots = data;
  },
  SET_APPOINTMENTS(state, data) {
    state.appointments = data;
  },
  SET_APPOINTMENT_SEARCH(state, data) {
    state.appointmentSearch = data;
  }
};

export const actions = {
  setAppointmentSearch({ commit }, payload) {
    commit("SET_APPOINTMENT_SEARCH", payload);
  },
  async setAppointment({ dispatch }, payload) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let result = await HTTP.post("OptusNBN/QueryAvailableSlots", payload);
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(result.data.data);
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async updateAppointment({ dispatch }, payload) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let result = await HTTP.post("OptusNBN/UpdateAppointment", payload);

      dispatch("processLoader/setProcessInactive", {}, { root: true });
      if (!result.success) {
        dispatch(
          "httpResponse/setHttpResponse",
          {
            text: "Timeslot is unavailable or already booked!",
            color: "error"
          },
          { root: true }
        );
      } else {
        dispatch(
          "httpResponse/setHttpResponse",
          { text: "Appointment has been updated!", color: "success" },
          { root: true }
        );
      }

      return Promise.resolve(result.data.data);
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async checkAvailableSlots({ dispatch, commit }, payload) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let result = await HTTP.post("OptusNBN/QueryAvailableSlots", payload);
      commit("SET_AVAILABLE_SLOTS", result.data.data.availableslot);
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(result.data.data);
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async getAppointments({ commit, dispatch, state }) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let result = await HTTP.post(
        "OptusNBN/GetAppointments",
        state.appointmentSearch
      );

      if (result.data) commit("SET_APPOINTMENTS", result.data);
      else commit("SET_APPOINTMENTS", []);

      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(result.data);
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async getAppointmentDetails({ dispatch }, orderId) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let result = await HTTP.get(`OptusNBN/GetAppointmentDetails/${orderId}`);
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(result.data.data);
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async checkNbnAvailableSlots({ dispatch }, payload) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let result = await HTTP.post("OptusNBN/NbnGetAvailableSlots", payload);
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(result);
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async checkNbnAllAvailableSlots({ dispatch }, payload) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let result = await HTTP.post("OptusNBN/NbnGetAllAvailableSlots", payload);
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(result);
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async createNbnAppointment({ dispatch }, payload) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let result = await HTTP.post("OptusNBN/NbnCreateAppointment", payload);
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(result);
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async getNbnAppointments({ dispatch }, payload) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let result = await HTTP.post("OptusNBN/GetNbnAppointments",
        payload);
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(result);
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async getNbnAppointment({ dispatch }, payload) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let result = await HTTP.post("OptusNBN/GetNbnAppointment",payload);
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(result);
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async cancelNbnAppointment({ dispatch }, payload) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let result = await HTTP.post("OptusNBN/CancelNbnAppointment",payload);
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(result);
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async updateNbnAppointment({ dispatch }, payload) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let result = await HTTP.post("OptusNBN/UpdateNbnAppointment",payload);
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(result);
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
};
